import clsx from "clsx";
import EAIcon from "components/common/EAIcon";
import { useMemo } from "react";
import useStyles from 'style/js-style/components/thirdparties/securityRating/SecurityRatingStyle';

const SecurityRatingScoreVariation = ({ delta, trend }) => {
  const { classes } = useStyles();

  const icon = useMemo(() => {
    switch (trend) {
      case 'UP':
        return 'arrow/arrow_upward_white';
      case 'DOWN':
        return 'arrow/arrow_downward_white';
      default:
        return null;
    }
  }, [trend])

  return (
    <div
      className={clsx(
        classes.scoreVariation,
        `trend-${trend}`,
      )}
    >
      <EAIcon icon={icon} style={{ width: '12px' }} />
      <span>{delta}</span>
    </div>
  )
}
export default SecurityRatingScoreVariation;